/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from 'react'
import PropTypes from 'prop-types'
import Cross from '../assets/images/compare-difference/cross.png'
import Check from '../assets/images/compare-difference/check.png'
import ContentfulButton from './Utilities/Buttons/ContentfulButton'

/* eslint-disable react/no-danger */
function DifferenceTable({ data }) {
  const {
    tableHeadline,
    columnOneHeader,
    columnOneLogo,
    columnOneLogoMobile,
    columnTwoHeader,
    columnTwoLogo,
    columnTwoLogoMobile,
    table,
    buttonCta
  } = data

  const getLogo = symbol => {
    if (symbol === 'Check') return Check
    return Cross
  }

  const rows = table?.tableData?.tableData?.map(row => {
    return row.length > 2 ? (
      <div className="compare-difference__row" key={row[0]}>
        <div>
          <p className="compare-difference__text">{row[0]}</p>
        </div>
        <div>
          <img
            src={getLogo(row[1])}
            alt={row[1]}
            className={`compare-difference__first-${row[1].toLowerCase()}`}
          />
        </div>
        <div>
          <img
            src={getLogo(row[2])}
            alt={row[2]}
            className={`compare-difference__second-${row[2].toLowerCase()}`}
          />
        </div>
      </div>
    ) : null
  })

  const ariaName = `${tableHeadline?.preHeaderText
    .toLowerCase()
    .replace(/\s/g, '-')}-${tableHeadline?.headerText.toLowerCase().replace(/\s/g, '-')}`

  return (
    <section className="compare-difference">
      <div
        className="container__inner"
        role="table"
        id={ariaName}
        aria-label={ariaName}
        aria-describedby={ariaName}
      >
        <div className="compare-difference__header-row">
          <h2>
            {tableHeadline?.preHeaderText} <br />
            <span className="compare-difference__blue">{tableHeadline?.headerText}</span>
          </h2>
          <div role="rowgroup" className="compare-difference__column-headers">
            <div role="row" className="compare-difference__column-header">
              <img
                src={columnOneLogo?.image?.file?.url}
                alt={columnOneLogo?.altText}
                className="compare-difference__logo"
              />
              <img
                src={columnOneLogoMobile?.image?.file?.url}
                alt={columnOneLogoMobile?.altText}
                className="compare-difference__mobile-logo"
              />
              <p role="columnheader">{columnOneHeader}</p>
            </div>

            <div role="row" className="compare-difference__column-header">
              <img
                src={columnTwoLogo?.image?.file?.url}
                alt={columnTwoLogo?.altText}
                className="compare-difference__logo"
              />
              <img
                src={columnTwoLogoMobile?.image?.file?.url}
                alt={columnTwoLogoMobile?.altText}
                className="compare-difference__mobile-logo"
              />
              <p role="columnheader">{columnTwoHeader}</p>
            </div>
          </div>
        </div>
        {rows}
        {buttonCta && (
          <div className="compare-difference__cta">
            <ContentfulButton data={buttonCta} />
          </div>
        )}
      </div>
    </section>
  )
}

DifferenceTable.propTypes = {
  data: PropTypes.object.isRequired
}

export default DifferenceTable
